import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { faTrash, faEdit } from "@fortawesome/free-solid-svg-icons";
//@ts-ignore cortex
///@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
import {
    IconTextButton,
    Button,
    Loading,
    Table,
    Pagination,
    Modal,
    //@ts-ignore cortex
} from "@cortexglobal/rla-components";

import { EmptyRow, PreviewImage } from "../../components/index";
import { Category } from "../../forms/CategoryForm";
import { Product } from "src/forms/ProductForm";

const PaddedDiv = styled.div`
    padding: 3em;
`;

const TableHeader = styled.div`
    cursor: pointer;
    display: inline-block;

    &:hover {
        text-decoration: underline;
    }
`;

export const ProductTable = ({
    items,
    loaded,
    path,
    pagination = null,
    deleteItem,
    onPageChange,
    onOrderBy,
    onPerPageChange,
}: ProductTableProps) => {
    const currentPage = pagination ? pagination.current_page : 1;

    const [deleteProductModalShowing, setDeleteProductModalShowing] =
        useState(false);
    const [deleteProductName, setDeleteProductName] = useState("");
    const [deleteProductId, setDeleteProductId] = useState(null);

    return (
        <React.Fragment>
            <Table>
                <thead>
                    <tr>
                        <th>{trans("Name")}</th>
                        <th>
                            <TableHeader
                                onClick={() => onOrderBy("external_identifier")}
                            >
                                {trans("External Identifier")}
                            </TableHeader>
                        </th>
                        {/* <th>
                            <TableHeader onClick={() => onOrderBy("order")}>
                                {trans("Order")}
                            </TableHeader>
                        </th> */}
                        <th>{trans("Image")}</th>
                        <th>{trans("Actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {!loaded ? (
                        <EmptyRow colSpan={"100%"}>
                            <Loading />
                        </EmptyRow>
                    ) : !items || items.length === 0 ? (
                        <EmptyRow colSpan={"100%"}>
                            {trans("No items found")}
                        </EmptyRow>
                    ) : (
                        items.map((item) => {
                            return (
                                <tr>
                                    <td>{item.name}</td>
                                    <td>{item.external_identifier}</td>
                                    {/* <td>{item.order}</td> */}
                                    <td>
                                        {item.thumbnail ? (
                                            <PreviewImage
                                                src={item.thumbnail}
                                            />
                                        ) : (
                                            trans("No image provided")
                                        )}
                                    </td>
                                    <td>
                                        <IconTextButton
                                            as={Link}
                                            to={`${path}/edit/${item.uuid}?page=${currentPage}`}
                                            showCircle={false}
                                            expanded={false}
                                            icon={faEdit}
                                        >
                                            {trans("Edit")}
                                        </IconTextButton>
                                        <IconTextButton
                                            type="alert"
                                            showCircle={false}
                                            expanded={false}
                                            icon={faTrash}
                                            onClick={(event) => {
                                                setDeleteProductId(item.uuid);
                                                setDeleteProductModalShowing(
                                                    true
                                                );
                                                setDeleteProductName(item.name);
                                            }}
                                        >
                                            {trans("Delete")}
                                        </IconTextButton>
                                    </td>
                                </tr>
                            );
                        })
                    )}
                </tbody>
            </Table>
            {pagination && (
                <Pagination
                    onPerPageChange={onPerPageChange}
                    style={{ clear: "both" }}
                    currentPage={pagination.current_page - 1}
                    perPage={pagination.per_page}
                    pageCount={pagination.last_page}
                    onPageChange={({ selected }) => onPageChange(selected + 1)}
                    {...pagination}
                />
            )}
            {deleteProductModalShowing && (
                <Modal
                    visible={deleteProductModalShowing}
                    onClose={() => {
                        setDeleteProductModalShowing(false);
                    }}
                >
                    <PaddedDiv>
                        <h3>
                            {trans(
                                "You are about delete: {deleteProductName}",
                                {
                                    deleteProductName,
                                }
                            )}
                        </h3>

                        <p>{trans("Are you sure you want to proceed?")}</p>
                        <Button
                            type="secondary"
                            style={{ marginRight: "1em" }}
                            onClick={() => {
                                setDeleteProductModalShowing(false);
                            }}
                        >
                            {trans("Cancel")}
                        </Button>
                        <Button
                            type="alert"
                            onClick={() => {
                                deleteItem(deleteProductId).then(() => {
                                    setDeleteProductModalShowing(false);
                                });
                            }}
                        >
                            {trans("Delete")}
                        </Button>
                    </PaddedDiv>
                </Modal>
            )}
        </React.Fragment>
    );
};

interface ProductTableProps {
    items: Product[];
    loaded: boolean;
    path: string;
    pagination?: any;
    deleteItem: (number) => Promise<Product[]>;
    onPageChange?: (number) => void;
    onOrderBy?: (string) => void;
    onPerPageChange?: ({ value }) => void;
}

export default ProductTable;
